import { render, staticRenderFns } from "./EmailMarketingViewPage.vue?vue&type=template&id=207680c5&"
import script from "./EmailMarketingViewPage.vue?vue&type=script&lang=js&"
export * from "./EmailMarketingViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports